







































    
	import { Component, Vue, Prop } from 'vue-property-decorator';
    import * as moment from 'moment';
	import momentTZ from 'moment-timezone';
	 import 'moment-duration-format';
	//import { CDR } from '../../../store';  
	import util from '../../../lib/util';
	import { Vuetable, VuetablePagination} from 'vuetable-2';
	import { mapState } from 'vuex';
	import { store, CDR, StoreState ,Timezone} from '../../../store';    
	import axios from 'axios';	
	@Component({
        components: {
            Vuetable,  
		},
		computed: {  
			...mapState({
				'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
				'call_history': (state: StoreState) => (state.dashboard as any).call_history,
                'showLoadMore': (state: StoreState) => (state.dashboard as any).call_history_load_more,
                'showLoading': (state: StoreState) => (state.dashboard as any).call_history_loader,
				'timezone': (state: StoreState) => state.reports.filters.timezone,
				'notificationvmid': (state: StoreState) => (state.dashboard as any).notificationvmid,
				
			})
		},
	})
	
	export default class CallHistory extends Vue {
		 timezone!: Timezone;
		 downloading:boolean=false;

		@Prop()
		public cdr!: CDR;
       data() {
            return {
				isLoading: false,
				downloadIMG:'img/icons/Download-icon1.png',
				playIMG:'img/icons/Play-fill.png',
				spinIMG:'img/icons/spinn_icon.gif',
			}
		}

       async created() {
			this.$data.cdrs = (this as any).call_history.cdrs;
			if ( this.$props.cdr.media_id===(this as any).notificationvmid)
			{
				 this.playVoicemail();
				   this.$store.commit("SET_NOTIFICATION_VM_ID",'');
           
			}
        }
        get callDirection() {
			return this.$props.cdr.call_direction === "outbound" ?  "Out" : "In";
		}

     //   get timeStamp() {
       //     return momentTZ(momentTZ(this.$props.cdr.timestamp, 'x').format()).format('YYYY-MM-DD hh:mma');
        //}
         get timeStamp() {
			 if (this.VM_icon_stats)
		 			return moment((this.$props.cdr.timestamp - 62167219200) * 1000).format("YYYY-MM-DD hh:mma");
			 else 
			 	  return momentTZ(momentTZ(this.$props.cdr.timestamp, 'x').format()).format('YYYY-MM-DD hh:mma');

		}
        get duration() {
			const min = Math.floor(this.$props.cdr.duration / 60);
			const sec = this.$props.cdr.duration % 60;
			const secString = (sec.toString() as any).padStart(2, '0');
			return `${min.toString()}:${secString}`;
		}
		
		get paly_status(){
           const min = Math.floor(this.$props.cdr.duration / 60);
			const sec = this.$props.cdr.duration % 60;
			var status=(min==0 && sec==0)? false:true;
			return status;
		}

        formatPhoneNumber(phoneNumber: any) {
		var phoneNumber=	phoneNumber.split("@");
		phoneNumber=phoneNumber[0];
			return util.formatPhoneNumber(phoneNumber);
        }
		formatDate ()
		{  
            return this.$props.cdr.call_direction;
        }

        quickCall(number) {
            this.$store.commit('QUICK_CALL', number);
		}

	 get title() {
			const dummy = this.$props.cdr.call_recording;
            const re = /call_recording_*.mp3$/;
            let res=dummy.split("/");; 
            return res[res.length-1];
        }
		
 		download() {  
			if(this.$props.cdr.call_recording!=null)
			this.downloading=true;
			const fileurl= this.$props.cdr.call_recording;
			 this.$store.dispatch('Download_paly', fileurl).then(response => {
            	this.downloading=false;
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', this.title); //or any other extension
				document.body.appendChild(link);
				link.click();
                }).catch(() => {
                    });
		}

		async downloadVoicemail()
		{
			this.downloading=true;
			let _vmattachment;
			await this.getvoicemailattachment().then(r => {
						 	_vmattachment=  r;
			});
			const audiourl=(_vmattachment as any).audiourl;
			const attachment=(_vmattachment as any).attachment;
			this.download_mycallrecord(audiourl,attachment);
		}

		download_mycallrecord(url, name) {  
		
			const fileurl= url;//this.$props.cdr.call_recording;
			// this.$store.dispatch('Download_paly', fileurl).then(response => {
            //	
				//const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', name); //or any other extension
				document.body.appendChild(link);
				link.click();
				this.downloading=false;
              //  }).catch(() => {

                //    });
		}
			
		saveAs(url) {    
			var filename = url.substring(url.lastIndexOf("/") + 1).split("?")[0];
			var xhr = new XMLHttpRequest();
			xhr.responseType = 'blob';
			xhr.onload = function() {
				var a = document.createElement('a');
				a.href = window.URL.createObjectURL(xhr.response);
				a.download = filename; 
				a.style.display = 'none';
				document.body.appendChild(a);
			}
		};

async getvoicemailattachment()
		{
			try {
			 	
				const voicemaildate = (this as any).timeStamp.split("-");
				 let m = voicemaildate[1];	
				 let y= voicemaildate[0];
				 var my= `${y}${m}`;
                const r = await this.$store.dispatch('getvoicemailaudioattachment',{media_id: this.$props.cdr.media_id, my: my} );
                 if(r) {

					const attachment= Object.keys(r.data._attachments)[0];
					const apiurl = r.data.APIServer;
					const dbname = r.data.dbname;
					const audiourl= `${apiurl}voicemailaudio/${dbname}/${this.$props.cdr.media_id}/${attachment}`;
					return {audiourl:audiourl,
						attachment:attachment
					};
					
                }
            }
            catch {
                return;
            }

		}
		async playVoicemail() {
            //this.$emit('playVoicemail', (this as any).audioURL, (this as any).timeStamp, this.$props.voicemail);
		 try {
			 		let _vmattachment;
			 		 await this.getvoicemailattachment().then(r => {
						 	_vmattachment=  r;
					 });
					 const audiourl=(_vmattachment as any).audiourl;
					 this.$emit('openModal',  (this as any).timeStamp , audiourl);
			       // this.download_mycallrecord(audiourl,attachment);
				  //this.$emit('playVoicemail', audiourl, (this as any).timeStamp, this.$props.voicemail);
                    this.$props.voicemail.folder = 'saved';
                }
            catch {
                return;
            }
		 
		 try {
                const success = await this.$store.dispatch('markVoicemailAsRead', this.$props.voicemail.media_id);
                if(success) {
                    this.$props.voicemail.folder = 'saved';
                }
            }
            catch {
                return;
			}
			
			 
		}

		openModal() {
		//	alert(0)
		    //var title="0_3587859745@10.10.24.52" ;  
			//var URL="https://s3-us-west-2.amazonaws.com/spokerecordings/173d9d1269761052da83512b3e47fbe7/call_recording_0_3587859745@10.10.24.52.mp3";
			//var URL="https://s3-us-west-2.amazonaws.com/spokerecordings/173d9d1269761052da83512b3e47fbe7/call_recording_0_7659796@10.10.24.52.mp3";
			this.$emit('openModal', this.title , this.$props.cdr.call_recording);
		}

        get icon_stats(){
			var time_status=this.duration=='0:00'?false: true;
			var call_record=this.$props.cdr.call_recording==null?false:true;
			var isVm= this.$props.cdr.type==="VM"
			var status=time_status&&call_record && !isVm?true:false;
            return status;// this.duration=='0:00'?false: true
		} 

		get VM_icon_stats(){
			var time_status=this.duration=='0:00'?false: true;
			var call_record=this.$props.cdr.call_recording==null?false:true;
			var isVm= this.$props.cdr.type==="VM"
			var status=time_status&&call_record && isVm?true:false;
            return status;// this.duration=='0:00'?false: true
		} 

		
		 
    }
